module.exports = __webpack_public_path__ + "static/img/hangye.fabc57f8.png";